import { Pipe, PipeTransform } from '@angular/core';
import { FormatType } from '../enums/format-type.enum';
import { FormatHelper } from '../helpers/format.helper';

@Pipe({
  name: 'dateTime',
  standalone: false,
})
export class DateTimePipe implements PipeTransform {
  transform(value: Date, includeTime = true): string {
    return FormatHelper.format(value, includeTime ? FormatType.DateTime : FormatType.Date);
  }
}
